<ga-badge
  class="tw:absolute tw:top-0 tw:right-0.5"
  gaTooltipControlMode="none"
  gaTooltipPlacement="bottom-start"
  variant="information"
  #tooltip="gaTooltip"
  [gaTooltip]="tooltipContent"
  i18n
>
  New
</ga-badge>
<ng-template #tooltipContent>
  <ga-tooltip-title>{{ config().title }}</ga-tooltip-title>
  <p>{{ config().body }}</p>
  <button class="ga-button ga-button--primary ga-button--small tw:mt-2" type="button" (click)="onDismiss()" i18n>
    Got it
  </button>
</ng-template>
